'use client'

import { createContext, useContext, useState, useEffect } from 'react'
import { usePathname } from 'next/navigation'

interface PendingNavContextValue {
  pendingHref: string | null
  setPendingHref: (href: string | null) => void
}

const PendingNavContext = createContext<PendingNavContextValue | null>(null)

export function PendingNavProvider({ children }: { children: React.ReactNode }) {
  const [pendingHref, setPendingHref] = useState<string | null>(null)
  const pathname = usePathname()

  useEffect(() => {
    setPendingHref(null)
  }, [pathname])

  return (
    <PendingNavContext.Provider value={{ pendingHref, setPendingHref }}>
      {children}
    </PendingNavContext.Provider>
  )
}

export function usePendingNav() {
  const ctx = useContext(PendingNavContext)
  return ctx
}
